import { render, staticRenderFns } from "./setRoleName.vue?vue&type=template&id=2da09b96&scoped=true"
import script from "./setRoleName.vue?vue&type=script&lang=js"
export * from "./setRoleName.vue?vue&type=script&lang=js"
import style0 from "./setRoleName.vue?vue&type=style&index=0&id=2da09b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da09b96",
  null
  
)

export default component.exports